import LocalizedStrings from 'localized-strings';

import { TeamMembersRequestStatus } from '__generated__/GQL';

export const locales = new LocalizedStrings({
  en: {
    amountLabel: 'Amount',
    cancelRequest: 'Cancel request',
    description: 'Description',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Requested on',
      [TeamMembersRequestStatus.Pending]: 'Requested on',
      [TeamMembersRequestStatus.Approved]: 'Requested on',
      [TeamMembersRequestStatus.Completed]: 'Executed on',
      [TeamMembersRequestStatus.Rejected]: 'Canceled on',
      [TeamMembersRequestStatus.Canceled]: 'Canceled on',
    },
    recipientLabel: 'Recipient',
    reseller: 'Reseller',
    transactionOut: 'Expense claim',
    userLabel: 'Label',
    vatRate: '{rate} % VAT',
  },
  fr: {
    amountLabel: 'Montant',
    cancelRequest: 'Annuler la demande',
    description: 'Description',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Demandé le',
      [TeamMembersRequestStatus.Pending]: 'Demandé le',
      [TeamMembersRequestStatus.Approved]: 'Demandé le',
      [TeamMembersRequestStatus.Completed]: 'Exécuté le',
      [TeamMembersRequestStatus.Rejected]: 'Annulé le',
      [TeamMembersRequestStatus.Canceled]: 'Annulé le',
    },
    recipientLabel: 'Bénéficiaire',
    reseller: 'Commerçant',
    transactionOut: 'Note de frais',
    userLabel: 'Libellé',
    vatRate: 'TVA {rate}\xa0%',
  },
} as const);
